<script setup lang="ts">
import type SiteBanner from '@store/content/entities/SiteBanner';

const { banner } = defineProps<{
    banner?: SiteBanner;
}>();

function openUrl() {
    if (banner?.link) {
        window.open(banner.link, '_blank');
    }
}
</script>

<template>
    <div class="shadow-level1 banner-root">
        <div
            v-if="banner"
            :class="{ clickable: banner?.link }"
            @click="openUrl"
        >
            <mr-blur-hash-image
                v-if="banner.desktopImageUrl"
                class="banner-desktop"
                :src="banner.desktopImageUrl"
                :alt="banner.title"
                :hash="banner.desktopBlurhash"
                :ratio="`${banner.desktopWidth}:${banner.desktopHeight}`"
            />
            <mr-blur-hash-image
                v-if="banner.mobileImageUrl"
                class="banner-mobile"
                :src="banner.mobileImageUrl"
                :alt="banner.title"
                :hash="banner.mobileBlurhash"
                :ratio="`${banner.mobileWidth}:${banner.mobileHeight}`"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner-root {
    border-radius: 12px;
    overflow: hidden;
}
.clickable {
    cursor: pointer;
}
.banner-mobile {
    display: none;
    width: 100%;
    border-radius: 12px;
}

.banner-desktop {
    display: block;
    margin: auto;
    width: 100%;
    border-radius: 12px;
}

@media (max-width: $app-mobile-max-width) {
    .banner-mobile {
        display: block;
    }

    .banner-desktop {
        display: none;
    }
}
</style>
